export default (scribe) => {
  scribe.api.Selection.prototype.updateFromRange = function (range) {
    this.selection.removeAllRanges()
    this.selection.addRange(range)
    this.range = range
  }
}
